import { createLogger } from '@app/logger';
import { isEmpty } from 'lodash';

const log = createLogger('platform-deploymet-config');

const consoleUrl = process.env.REACT_APP_CONSOLE_URL || 'http://localhost:4000';

const firebaseConfigKey =
  process.env.REACT_APP_FIREBASE_CONFIG_KEY || 'devtest';

const isDevtest = firebaseConfigKey === 'devtest';
// const isDevtest = false; // TEMP local testing

const deploymentConfig = {
  firebaseConfigKey,

  // TODO: remove the need for separate bucket config (manual permission issue?)
  gcsAudioStorageBucket:
    process.env.REACT_APP_GCS_AUDIO_STORAGE_BUCKET || 'jw-devtest',

  gcsFirebaseBucket:
    process.env.REACT_APP_GCS_FIREBASE_BUCKET || 'jw-devtest-pub',

  // when true, then group media from all channels into a base 'dev' folder, otherwise segregate by channel slug.
  // allows better caching of ingestion assets for testing but better segregation for editorial deployment
  isDevtest,
  // defaultStorageSilo:
  //   process.env.REACT_APP_DEFAULT_STORAGE_SILO || isDevtest ? 'dev' : null,

  consoleUrl,
  // these are just aliases for 'consoleUrl' now that we've unified the apps
  scriptEditorUrl: consoleUrl,
  chaatUrl: consoleUrl,
  reviewToolUrl: consoleUrl,
  // scriptEditorUrl: process.env.REACT_APP_SCRIPT_EDITOR_URL || 'http://localhost:4100',
  // chaatUrl: process.env.REACT_APP_CHAAT_URL || 'http://localhost:4200',
  // reviewToolUrl: process.env.REACT_APP_REVIEW_TOOL_URL || 'http://localhost:4300',

  spaBaseUrl:
    process.env.REACT_APP_SPA_BASE_URL ||
    /*'http://localhost:3100',*/ 'https://editorial.jiveworld.app',

  masalaServerUrl:
    process.env.REACT_APP_MASALA_SERVER_URL || 'http://localhost:4500',
  falconServerUrl:
    process.env.REACT_APP_FALCON_SERVER_URL || 'http://localhost:4600',
  railsServerUrl:
    process.env.REACT_APP_RAILS_SERVER_URL || 'http://localhost:3000',

  // faunadbSecret:
  //   process.env.REACT_APP_FAUNADB_SECRET ||
  //   'fnAENPkFEnACQahQArJBLOnLk5wKebc3jkdBAu5H', // devtest-masala
  slackApiToken: '',
  slackConversationsChannel:
    process.env.REACT_APP_SLACK_CONVERSATIONS_CHANNEL || 'masala-testing-feed',
  // these are used once to generate the token
  slackClientId: process.env.REACT_APP_SLACK_CLIENT_ID,
  slackClientSecret: process.env.REACT_APP_SLACK_CLIENT_SECRET,

  sentryDsn: process.env.REACT_APP_SENTRY_DSN || null,
  errorReportingEnabled:
    process.env.REACT_APP_ERROR_REPORTING_ENABLED === 'true',

  linearApiKey: '',
  linearEditorialTeamId: '',

  // suppressAutoExport: false,
  suppressAutoExport: true, // tmp, makes testing faster

  // dynamically fetched after logging in
  openAiApiKey: '',
  openRouterApiKey: '',

  // 'simulation' can be set into your local.env for UI testing
  defaultLlmModelKey:
    process.env.REACT_APP_DEFAULT_LLM_MODEL_KEY || 'openai/gpt-4-1106-preview', // 'openai/gpt-4-32k',
};

// note, this gets called concurrently during startup, but not worth worrying about
export const ensureDynamicConfig = async () => {
  log.info('ensureDynamicConfig start');
  if (isEmpty(deploymentConfig.openAiApiKey)) {
    log.info('ensureDynamicConfig fetchDynamicConfig');
    await fetchDynamicConfig();
    log.info('ensureDynamicConfig fetchDynamicConfig done');
  } else {
    log.info('ensureDynamicConfig already have config');
  }
};

export const fetchDynamicConfig = async () => {
  const url = `${deploymentConfig.masalaServerUrl}/clientConfig`;
  log.info(`fetchDynamicConfig: ${url}`);
  const response = await fetch(url);
  const data = await response.json();
  log.info('fetchDynamicConfig:', data);
  deploymentConfig.openAiApiKey = data.openAiApiKey;
  deploymentConfig.openRouterApiKey = data.openRouterApiKey;
  deploymentConfig.linearApiKey = data.linearApiKey;
  deploymentConfig.linearEditorialTeamId = data.linearEditorialTeamId;
  deploymentConfig.slackApiToken = data.slackApiToken;
};

export const platformDeploymentConfig = deploymentConfig;
